import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { SCARPING_TYP } from '@constants/codeConstants';

const AnalysisGuideTemplate = ({ userInfo, familiyData }) => {
  const { reqCd } = useParams();

  console.log(reqCd);

  /* 요청 타입명 반환 */
  const getReqTypeName = useCallback((type) => {
    const types = {
      [SCARPING_TYP.MECHUP]: '건강검진 분석',
      [SCARPING_TYP.HIRA_MEDICATION]: '처방약 AI 분석',
      [SCARPING_TYP.HELT]: '건강예측 분석',
    };
    return types[type] || '';
  }, []);

  /* 말풍선 cmp */
  const AnalysisDescription = ({ type }) => {
    const descriptions = {
      [SCARPING_TYP.MECHUP]: {
        title: '건강검진 연동이란?',
        content: (
          <>
            10년 치 건강검진 기록을 불러와
            <br />
            한눈에 볼 수 있게 모아줍니다.
          </>
        ),
        icon: '/assets/images/ico_h_hospital.svg',
      },
      [SCARPING_TYP.HIRA_MEDICATION]: {
        title: '처방약 AI 분석이란?',
        content: (
          <>
            1년 치 처방전을 한 번에 모아
            <br />
            과처방, 중복약, 노인주의 성분을
            <br />
            찾을 수 있어요~
          </>
        ),
        icon: '/assets/images/ico_h_pharmacy.svg',
      },
      [SCARPING_TYP.HELT]: {
        title: '건강예측 연동이란?',
        content: (
          <>
            건강검진 결과의 주요 요인을 분석해
            <br />
            5대 질병 위험요인을 미리 확인할 수 있습니다.
          </>
        ),
        icon: '/assets/images/ico_h_target.svg',
      },
    };

    const desc = descriptions[type];

    return (
      desc && (
        <div className="bubble mt-20">
          <div>
            <img src={desc.icon} className="bi_symbol" />
          </div>
          <div className="mt-10 fs-20 fw-e">{desc.title}</div>
          <div className="mt-10">{desc.content}</div>
        </div>
      )
    );
  };

  return (
    <>
      <div className="info_wrap Padding-20 pt-80">
        <div className="chat_ui">
          <div>
            <img src="/assets/images/ico_bi_symbol.svg" className="bi_symbol" />
          </div>
          <div>
            <div className="bubble">
              {familiyData.userNm}님께서
              <br />
              {userInfo.userNm}({familiyData.careObjRelCdNm})님께 <strong>{getReqTypeName(reqCd)}</strong>을 위해 인증을 요청했습니다.
            </div>
            <AnalysisDescription type={reqCd} />
          </div>
        </div>
      </div>
    </>
  );
};

export default AnalysisGuideTemplate;
